/**
 * storyEngineSqlApi: the SQL the engine ran for one render of a Story item.
 *
 *   GET /api/v2/story/{s}/renders/{r}/items/{i}/engine-sql
 *     -> {status: "pending"|"ready"|"unavailable", dialect, statements[], message}
 *
 * The text is the engine's own, as it ran (after the Story's filters); it is never rebuilt here
 * and never logged. Needs the Story-manage right: a 403 is an answer the caller words.
 */
import { apiService } from "../api";

export interface StoryEngineSqlStatementApi {
  output: string | null;
  /** Null when the result expired (`available` false). */
  sql: string | null;
  counts: string[];
  ran_at: string | null;
  truncated: boolean;
  available: boolean;
}

export interface StoryEngineSqlApi {
  status: "pending" | "ready" | "unavailable";
  dialect: string;
  statements: StoryEngineSqlStatementApi[];
  message: string | null;
}

export const readStoryEngineSql = (storyId: string, renderId: string, itemId: string): Promise<StoryEngineSqlApi> =>
  apiService.get<StoryEngineSqlApi>(`/api/v2/story/${storyId}/renders/${renderId}/items/${itemId}/engine-sql`);
